import React from 'react';
import keyword_extractor from 'keyword-extractor';
import { TagCloud } from 'react-tagcloud';
import axios from 'axios';
import Filter from 'bad-words';

import { reportError } from '../../utils/error-handling-service';

class Tags extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      tags: [],
    };
  }

  componentDidMount() {
    axios
      .get('https://www.googleapis.com/youtube/v3/commentThreads', {
        params: {
          part: 'snippet',
          videoId: this.props.youtubeVideoId,
          maxResults: 100,
          key: process.env.REACT_APP_YOUTUBE_DATA_API_KEY,
        },
      })
      .then(response => {
        const comments = response.data;
        this.extractionResult(comments);
      })
      .catch(function(error) {
        reportError('LOAD_TAG_CLOUD_ERROR', error.message);
      });
  }

  occurenceCount = resultArray => {
    resultArray.sort();
    const countResult = [];
    let current = null;
    let count = 0;
    for (var i = 0; i < resultArray.length; i++) {
      if (resultArray[i] != current) {
        if (count > 0) {
          let result = {
            value: current,
            count: count,
          };
          countResult.push(result);
        }
        current = resultArray[i];
        count = 1;
      } else {
        count++;
      }
    }
    if (count > 0) {
      let result = {
        value: current,
        count: count,
      };
      countResult.push(result);
    }
    return countResult;
  };

  extractionResult = comments => {
    const resultArray = [];
    const profanityFilter = new Filter({ placeHolder: '/' });

    for (let i = 0, itemsLength = comments.items.length; i < itemsLength; i++) {
      let extractedItems = keyword_extractor.extract(
        comments.items[i].snippet.topLevelComment.snippet.textOriginal,
        {
          language: 'english',
          remove_digits: true,
          return_changed_case: true,
          remove_duplicates: false,
        },
      );

      for (
        let t = 0, extractedLength = extractedItems.length;
        t < extractedLength;
        t++
      ) {
        let item = extractedItems[t];
        let itemCleaned = profanityFilter.clean(item);
        let itemDecluttered = itemCleaned.replace(/[^A-Za-z;]/g, '');

        if (itemDecluttered.length > 3 && itemDecluttered.length < 30) {
          resultArray.push(itemDecluttered);
        }
      }
    }
    const tagArray = this.occurenceCount(resultArray);
    const sortedArray = tagArray.sort(function(a, b) {
      return b.count > b.count ? 1 : a.count > b.count ? -1 : 0;
    });
    this.setState({ tags: tagArray.slice(0, 40) });
  };

  render() {
    const data = this.state.tags;

    return (
      <div>
        {this.state.tags.length > 0 &&
          <TagCloud
            minSize={16}
            maxSize={36}
            tags={data}
            className="tag-cloud"
          />}
      </div>
    );
  }
}

export default Tags;



/** WEBPACK FOOTER **
 ** ./src/components/tags/index.js
 **/